export const resources_flux = {
  en: {
    translation: {
      Flux: {
        pg: 'General settings',
        pdl: 'Font',
        pl: 'Parameters per link',
        src: 'Origin',
        trgt: 'Destination',
        value: 'Value',
        calculated_value: 'Comp. Val',
        type: 'Format',
        if: 'Reverse direction',
        dzf: 'Overlaying order',
        style: 'Style',
        as: 'Apply the style to selected link(s)',
        IB: 'ToolTip',
        IS: 'Additional info.',
        ajust_label: 'Adjust labels position',
        FS: 'Link',
        local_scale: 'Local link scale',
        changePlan: 'Change plan of flows',
        mask_attr: 'Change flow\'s attributes',
        tooltips: {
          src: 'Choice of the departure node for the selected link(s)',
          trgt: 'Choice of the arrival node for the selected link(s)',
          if: 'Reverse the start and finish nodes for the selected link(s)',
          up: 'Move up one step to the foreground',
          upup: 'Put the selected stream(s) in the foreground',
          dwn: 'Go down one step to the last plane',
          dwndwn: 'Move the selected stream(s) to the last plane',
          as: 'Allow to apply a predefined style in the preferences menu to the selected link(s)',
          IB: 'Tooltip : text formatted in HTML and displayed with the tooltip of the link. This tooltip pops on graphic space with SHIFT + MOUSE on the link.',
          ajust_label: 'Reposition links labels above the links if they\'re taller than link stroke',
          inv: 'Inverse the target and the source'
        },
        data: {
          données: 'Data',
          vpp: 'Value',
          data_type: 'Data type',
          value: 'Value',
          ratio_input: 'Ratio total input',
          ratio_output: 'Ratio total output',
          ratio_source_parent: 'Ratio parent flux(left)',
          ratio_target_parent: 'Ratio parent flux(right)',
          unit_ratio: 'Coeff. units conversion',
          edit_value: 'Edit value',
          value_target: 'Dest. value',
          tab_basic: 'Basic',
          tab_afm: 'AFM',
          data_min: 'Min',
          data_max: 'Max',
          uncertainty: 'Uncertainty',
          affichage: 'Label',
          tooltips: {
            data_type: 'Data type',
            vpp: 'Data associated to the selected link and, if existing, for the selected tag(s)',
            scientificNotation: 'Activate or not the notation in scientific format, for the display of the link\'s data on the Sankey diagram',
            affichage: 'Replacement text for the display of the link\'s data on the Sankey diagram',
            value_target: 'Destination value for tapered links (leave empty for uniform thickness)',
            data_min: 'Minimum bound for the flow value (used for reconciliation)',
            data_max: 'Maximum bound for the flow value (used for reconciliation)',
            uncertainty: 'Relative uncertainty in % on the flow value (used for reconciliation)',
            tab_basic_disabled: 'Select "Value" as data type in the AFM tab to enable this panel'
          }
        },
        apparence: {
          anchor: 'Anchors',
          handle: 'Handles',
          apparence: 'Appearance',
          flow: 'Flow',
          fond: 'shape background',
          source: 'Source node',
          target: 'Target node',
          couleur: 'Color',
          color_source: 'Element defining flow color',
          grad: 'Gradient',
          shape_is_dashed: 'Dashed',
          of: 'Orientation',
          type: 'Type',
          courbe: 'Curve',
          fleche: 'Arrow',
          opacity: 'Opacity',
          arrow_size: 'Size of arrow',
          display_link_lab: 'Display value',
          hide_link_lab: 'Hide value',
          display_link_name: 'Display name',
          hide_link_name: 'Hide name',
          data_off_scale: 'Scale',
          tooltips: {
            color_source: {
              def: 'Choose what rule define flow color :',
              flow: 'Color is defined by flow parameter (default color, flow tag\'s color or data tag\'s color)',
              source: 'Color is defined by source node color',
              target: 'Color is defined by target node color',
              gradient: 'Color is a gradient from source node color to target node color',
              auto: 'Color is determined automatically using this priority:\n1. Common color tag between source and target\n2. Only one side has a color tag → take that side\n3. Both have tags (no common) → prefer the product node\n4. No color tags → prefer the product node\n5. Fallback: source color',
              disabled: 'Rule doesn\'t allow to choose flow color'
            },
            couleur: 'Choose the color for the selected link(s)',
            grad: 'Apply a gradient color effect on the selected link(s). The gradient is done between the color of the start node and the color of the end node',
            shape_is_dashed: 'Applies a hatch effect on the selected link(s)',
            of_vv: 'Allows to orient the beginning of the link vertically and the end of the link vertically',
            of_hh: 'Allows to orient the beginning of the link horizontally and the end of the link horizontally',
            of_hv: 'Allows to orient the beginning of the link horizontally and the end of the link vertically',
            of_vh: 'Allows to orient the beginning of the link vertically and the end of the link horizontally',
            courbe: 'Represents the selected link(s) as a Bezier curve',
            fleche: 'Represents the selected link(s) with an arrow tip at the end',
            structure: 'Represents the selected link(s) as if they didn\'t have values no matter their true value',
            starting_curve: 'Allows to refine the position of the starting point of curvature for the selected link(s). This value is a ratio (%) of the link\'s lenght relative to the starting point of the link.',
            ending_curve: 'Allows to refine the position of the ending point of curvature for the selected link(s). This value is a ratio (%) of the link\'s lenght relative to the starting point of the link.',
            starting_tangeant: 'Setting the radius of the starting curvature in case the selected link(s) are represented as Bezier curve(s)',
            ending_tangeant: 'Setting the radius of the ending curvature in case the selected link(s) are represented as Bezier curve(s)',
            arrow_size: 'Change the size of the arrow (from the end of the link to the node)',
            data_off_scale: 'Define a scale for this flow, wich can break the coherence of flow thickness proportionality of value ',
            local_scale: 'Define a local scaling factor that will be multiplied by the multiplier specified for this flow.'
          }
        },
        labels: {
          value: 'Value',
          intervals: 'Intervals',
          percent: '%',
          ratio: 'Ratio',
          label: 'Label',
          vdb: 'Label value',
          len: 'Black label',
          lb: 'White label',
          lec: 'Colored label',
          pos: 'Position',
          milieu: 'Middle',
          deb: 'Start',
          fin: 'End',
          dessous: 'Above',
          dessus: 'Below',
          pls: 'Manual positioning of the label',
          l_u_v: 'Unit',
          l_u: 'Unit\'s name',
          tooltips: {
            label: 'Display or not the label (data / text) associated to the selected link(s)',
            len: 'Display the label in black, for the selected stream(s)',
            lb: 'Display the label in white, for the selected stream(s)',
            lec: 'Display the label with the same color(s) as the one(s) associated with the selected stream(s)',
            deb: 'For the selected link(s), allows to position the label towards the starting point of the link',
            milieu_h: 'For the selected link(s), allows to position the label between the starting point and the end point of the link',
            end: 'For the selected stream(s), allows to position the label towards the end point of the stream',
            below: 'For the selected stream(s), allows to position the label below the stream',
            milieu_v: 'For the selected link(s), allows to position the label inside the link',
            top: 'For the selected stream(s), allows to position the label above the stream',
            pls: 'Combination Alt/left click move the label of the selected stream(s)',
            l_u_v: 'Display the unit of the links',
            l_u: 'Choose the name of the unit',
            unit_factor: 'Factor of conversion for link unity'
          }
        },
        layout: 'Disposition',
        layoutUp: 'Move forward',
        layoutTop: 'Move to the top',
        layoutDown: 'Move backward',
        layoutBottom: 'Move to the bottom',
      }
    }
  },
  fr: {
    translation: {
      Flux: {
        pg: 'Paramètres généraux',
        pdl: 'Police des labels',
        pl: 'Paramètres par flux',
        src: 'Origine',
        trgt: 'Destination',
        value: 'Valeur',
        calculated_value: 'Val. Calc.',
        type: 'Format',
        if: 'Inverser le sens',
        dzf: 'Superposition d\'affichage',
        style: 'Style',
        as: 'Réinitialiser',
        IB: 'Info-bulle',
        IS: 'Info sup.',
        ajust_label: 'Position vertical ajusté',
        local_scale: 'Échelle propre au flux',
        FS: 'Flux',
        changePlan: 'Modifier le plan des flux',
        mask_attr: 'Changer des attributs',
        tooltips: {
          src: 'Choix du noeud de départ pour le/les flux sélectionné(s)',
          trgt: 'Choix du noeud d\'arrivée pour le/les flux sélectionné(s)',
          if: 'Permet d\'inverser les noeuds de départ et d\'arrivée pour le/les flux sélectionné(s)',
          up: 'Monter d\'un cran vers le premier plan',
          upup: 'Mettre le/les flux selectionné(s) au premier plan',
          dwn: 'Descendre d\'un cran vers le dernier plan',
          dwndwn: 'Mettre le/les flux sélectionné(s) au dernier plan',
          as: 'Permettre d\'appliquer un style prédéfini dans le menu préférence au(x) flux selectionné(s)',
          IB: 'Info bulle : texte formaté en HTML et affiché avec l\'info-bulle du flux. Cet info-bulle apparait sur espace graphique avec SHIFT + SOURIS sur le flux',
          ajust_label: 'Repositionne les labels de flux au dessus si les labels sont plus grand que l\'épaisseur des flux',
          inv: 'Inverse le sens du flux en inversant sa source et sa cible'
        },
        data: {
          edit_value: 'Éditer la valeur',
          données: 'Données',
          vpp: 'Valeur',
          data_type: 'Type de données',
          value_type: 'Type de données',
          ratio: 'Type de ratio',
          node_ref: 'Relatif à',
          dir: 'Flux pris en compte',
          value: 'Valeur',
          ratio_input: 'Ratio total entrées',
          ratio_output: 'Ratio total sorties',
          ratio_source_parent: 'Ratio flux parent(à gauche)',
          ratio_target_parent: 'Ratio flux parent(à droite)',
          unit_ratio: 'Coeff. conversion unités',
          value_target: 'Valeur dest.',
          tab_basic: 'Basique',
          tab_afm: 'AFM',
          data_min: 'Min',
          data_max: 'Max',
          uncertainty: 'Incertitude',
          affichage: 'Label',
          tooltips: {
            data_type: 'Type de données',
            vpp: 'Valeur associée au flux sélectionné et, si existant(s), pour le/les tag(s) de flux selectionné(s)',
            scientificNotation: 'Activer ou non la notation en format scientifique, pour l\'affichage de la valeur du flux sur le diagramme de Sankey',
            affichage: 'Texte de remplacement de l\'affichage de la valeur du flux sur le diagramme de Sankey',
            value_target: 'Valeur à la destination pour les flux en forme de trapèze (laisser vide pour une épaisseur uniforme)',
            data_min: 'Borne inférieure de la valeur du flux (utilisée pour la réconciliation)',
            data_max: 'Borne supérieure de la valeur du flux (utilisée pour la réconciliation)',
            uncertainty: 'Incertitude relative en % sur la valeur du flux (utilisée pour la réconciliation)',
            tab_basic_disabled: 'Sélectionnez "Valeur" comme type de données dans l\'onglet AFM pour activer ce panneau'
          }
        },
        apparence: {
          anchor: 'Ancres',
          handle: 'Poignées',
          apparence: 'Apparence',
          fond: 'Fond',
          couleur: 'Couleur',
          grad: 'Gradient',
          flow: 'Flux',
          color_source: 'Élement définissant la couleur du flux',
          source: 'Noeud source',
          target: 'Noeud cible',
          shape_is_dashed: 'Hachuré',
          of: 'Orientation',
          type: 'Type',
          courbe: 'Courbe',
          fleche: 'Flèche',
          opacity: 'Opacité',
          arrow_size: 'Taille',
          display_link_lab: 'Afficher la valeur',
          hide_link_lab: 'Masquer la valeur',
          display_link_name: 'Afficher le texte',
          hide_link_name: 'Masquer le texte',
          data_off_scale: 'Échelle',

          bezier_path: 'Chemin Bezier',
          bezier_outline: 'Contour Bezier',
          tooltips: {
            couleur: 'Choisir la couleur pour le/les flux sélectionné(s)',
            color_source: {
              def: 'Choisir la règle qui définit la couleur du flux',
              flow: 'La couleur est définie par les paramètres du flux (couleur par défaut, couleur des étiquettes de flux ou des données)',
              source: 'La couleur est définie par la couleur du nœud source',
              target: 'La couleur est définie par la couleur du nœud cible',
              gradient: 'La couleur est un dégradé de la couleur du nœud source vers la couleur du nœud cible',
              auto: 'La couleur est déterminée automatiquement selon cet ordre de priorité :\n1. Tag couleur commun entre source et cible\n2. Un seul côté a un tag couleur → prendre ce côté\n3. Les deux ont des tags (pas de commun) → préférer le nœud produit\n4. Pas de tags couleur → préférer le nœud produit\n5. Par défaut : couleur source',
              disabled: 'La règle ne permet pas de modifier la couleur du flux'
            },
            grad: 'Applique un effet de gradient de couleur sur le/les flux sélectionné(s). Le gradient est réalisé entre la couleur du noeud de départ et celle du noeud d\'arrivée',
            shape_is_dashed: 'Applique un effet de hachure sur le/les flux sélectionné(s)',
            of_vv: 'Permet d\'orienter le début du flux verticalement et la fin du flux verticalement',
            of_hh: 'Permet d\'orienter le début du flux horizontalement et la fin du flux horizontalement',
            of_hv: 'Permet d\'orienter le début du flux horizontalement et la fin du flux verticalement',
            of_vh: 'Permet d\'orienter le début du flux verticalement et la fin du flux horizontalement',
            courbe: 'Représente le/les flux sélectionné(s) sous forme de courbe(s) de Bezier.',
            fleche: 'Représente le/les flux sélectionné(s) avec une pointe de flèche à la fin.',
            structure: 'Représente le/les flux sélectionné(s) comme si il n\'avait pas de valeur peu importe leur vraie valeur ',
            arrow_size: 'Modifie la taille de la flèche (largeur entre la fin du flux et le noeud',
            data_off_scale: 'Définie une échelle local pour l\'épaisseur du flux, cela peut casser la cohérence du diagramme au niveau de la proportionalité entre la valeur des flux et leur épaisseur ',
            local_scale: 'Définissez un facteur d\'échelle local qui sera multiplié par le multiplicateur spécifié pour ce flux.'
          }
        },
        labels: {
          source: 'Noeud source',
          target: 'Noeud destination',
          percent: '%',
          intervals: 'Intervalles',
          ratio: 'Ratio',
          label: 'Label',
          vdb: 'Valeur',
          len: 'Label en noir',
          lec: 'Label en couleur',
          milieu: 'Milieu',
          deb: 'Début',
          fin: 'Fin',
          dessous: 'Dessous',
          dessus: 'Dessus',
          pls: 'Positionnement manuel du label',
          scientificNotation: 'Notation scientifique',
          significantDigits: 'Chiffres significatifs',
          NbDigit: 'Nombre maximum de décimales',
          unit_name: 'Unité personnalisée',
          value: 'Valeur',
          '%IS': 'Flux en entrées du noeud source',
          '%ID': 'Flux en entrées du noeud destination',
          '%OS': 'Flux en sorties du noeud source',
          '%OD': 'Flux en sorties du noeud destination',
          '%PS': 'Flux parent du noeud source',
          '%PD': 'Flux parent du noeud destination',
          unit_ratio: 'Ratio d\'unité',
          unit_tag: 'Unité naturelle d\'origine',
          other_unit_tag: 'Autres unités naturelles',
          normalized: 'Normalisé (flux réf.)',
          unit_factor: 'Facteur d\'unité',
          labels: 'Nom',
          node_value: 'Valeur',
          name_label_is_visible: 'Label',
          lb: 'Blanc',
          pos: 'Position',
          pos_v: 'Position de la valeur',
          tp: 'Taille de police',
          tooltips: {
            label: 'Permet d\'afficher ou non le label (donnée / texte) associé au(x) flux sélectionné(s)',
            len: 'Afficher le texte du label en noir, pour le(s) flux sélectionné(s)',
            lb: 'Afficher le texte du label en blanc, pour le(s) flux sélectionné(s)',
            lec: 'Afficher le texte du label avec la/les même(s) couleur(s) que celle(s) associée(s) au(x) flux sélectionné(s)',
            deb: 'Pour le/les flux sélectionné(s), permet de positionner le texte du label vers le point de départ du flux',
            milieu_h: 'Pour le/les flux sélectionné(s), permet de positionner le texte du label entre le point de départ et le point d\'arrivée du flux',
            fin: 'Pour le/les flux sélectionné(s), permet de positionner le texte du label vers le point d\'arrivée du flux',
            dessous: 'Pour le/les flux sélectionné(s), permet de positionner le texte du label en dessous du flux',
            milieu_v: 'Pour le/les flux sélectionné(s), permet de positionner le texte du label dans le flux',
            dessus: 'Pour le/les flux sélectionné(s), permet de positionner le texte du label au dessus du flux',
            pls: 'La combinaison Alt/click gauche déplace le label du/des flux sélectionné(s)',
            value: 'Valeur',
            '%IS': 'Flux en entrées du noeud source',
            '%ID': 'Flux en entrées du noeud destination',
            '%OS': 'Flux en sorties du noeud source',
            '%OD': 'Flux en sorties du noeud destination',
            '%PS': 'Flux parent du noeud source',
            '%PD': 'Flux parent du noeud destination',
          }
        },
        layout: 'Organiser',
        layoutUp: 'Avancer',
        layoutTop: 'Premier plan',
        layoutDown: 'Reculer',
        layoutBottom: 'Dernier plan',
      }
    }
  }
}